<template lang="pug">
  .productionChart
    highcharts(
      :options="options"
      :updateArgs="updateArgs"
      ref="chart"
    )
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import More from 'highcharts/highcharts-more'
More(Highcharts)

export default {
  name: 'CopperProductionChart',
  props: {
    data: {},
    height: {},
    width: {},
    aiscChartField: {},
    exchangeRate: {}
  },
  data: function () {
    return {
      updateArgs: [true, true, { duration: 1000 }]
    }
  },
  components: {
    highcharts: Chart
  },
  watch: {
  },
  computed: {
    options () {
      let op = {
        chart: {
          animation: true,
          width: this.width,
          height: this.height
        },
        title: {
          text: ''
        },
        legend: {
          enabled: true
        },
        xAxis: {
          categories: this.data.labels
        },
        yAxis: [{
        // Primary
          labels: {
            format: '{value}'
          },
          title: {
            text: 'Production per Year (kt)'
          }
        },
        // Secondary
        {
          labels: {
            // eslint-disable-next-line no-template-curly-in-string
            format: '${value}'
          },
          title: {
            text: 'C1 Costs ($/t)'
          },
          opposite: true
        }
        ],
        tooltip: {
          followPointer: true,
          shared: true,
          valueDecimals: 0
        },
        plotOptions: {
          column: {
            stacking: 'normal'
          }
        },
        credits: {
          enabled: false
        },
        series: [
          {
            name: 'Gold Production (Copper-Eq)',
            type: 'column',
            color: '#cedbb4',
            data: this.data.goldProductionCopperEq,
            legendIndex: 2
          },
          {
            name: 'Copper Production',
            type: 'column',
            color: '#d7a35e',
            data: this.data.copperProduction,
            legendIndex: 1
          },
          {
            name: 'C1 Costs ($/t)',
            type: 'spline',
            color: '#a8bfac',
            data: this.data[this.aiscChartField].map((x) => {
              return x * this.exchangeRate
            }),
            yAxis: 1,
            legendIndex: 10

          }
        ]
      }
      if (this.data.silverProductionCopperEq.reduce(function (a, b) { return a + b }) > 0) {
        op['series'].unshift({
          name: 'Silver Production (Copper-Eq)',
          type: 'column',
          color: '#d7a35e',
          data: this.data.silverProductionCopperEq,
          legendIndex: 3
        })
      }
      if (this.data.molybdenumProductionCopperEq.reduce(function (a, b) { return a + b }) > 0) {
        op['series'].unshift({
          name: 'Molybdenum Production (Copper-Eq)',
          type: 'column',
          color: '#CACFD3',
          data: this.data.molybdenumProductionCopperEq,
          legendIndex: 4
        })
      }
      if (this.data.rheniumProductionCopperEq.reduce(function (a, b) { return a + b }) > 0) {
        op['series'].unshift({
          name: 'Rhenium Production (Copper-Eq)',
          type: 'column',
          color: '#BFCEDE',
          data: this.data.rheniumProductionCopperEq,
          legendIndex: 5
        })
      }
      return op
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
  }
}
</script>
